@if (!checkoutComplete) {
  <div class="enrollment-container">
    <div class="mb-3">
      <div class="enrollment-title">
        <mwp-text-translate text="Enrollment Session" jsonKey="enrollmentSession" />
        <span class="ms-1">
          - {{enrollmentManagerService.manager.enrollmentMode?.name}}
        </span>
      </div>
      <div class="card-container">
        <div class="content categories-info mb-3">
          <mwp-text-translate text="Below are the benefit categories in which you have one or more eligible benefit options available.  Categories preceded by a red circle require that you elect a benefit, waive coverage, or review your options.  Categories with a green check mark indicate the proceeding requirement has been completed.  Once all red circle categories have been completed, the Checkout section will become available.  You MUST CHECKOUT to complete your enrollment.  If you do not complete the checkout process for your session, any benefit requests you have made will not be processed." jsonKey="categoriesInfo2" />
        </div>
      </div>
    </div>
    <div class="row me-0">
    @if (displayTimeline) {
      <div class="col-2 category-selection">
        <div class="content-container">
          <div class="title pb-0 d-flex justify-content-center text-uppercase">
            <mwp-text-translate text="Categories" jsonKey="categories" />
          </div>
          <div>
            <mwp-benefit-enrollment-time-line
              [benefitCategories]="enrollmentManagerService.manager.benefitCategories"
              [isCheckoutEnabled]="enrollmentManagerService.manager.isCheckoutEnabled" />
          </div>
          @if (selectedMemberBenefitFlyout || isCategoryHTMLAvailable) {
            <div class="footer">
              @if (selectedMemberBenefitFlyout) {
                <div class="w-100 my-3">
                  <button class="mwp-button px-2 w-100" (click)="openDeductionSummaryDialog()">
                    <mwp-text-translate text="Deduction Summary" jsonKey="deductionSummary" />
                  </button>
                </div>
              }
              @if (isCategoryHTMLAvailable) {
                <div class="w-100">
                  <button class="mwp-button-secondary px-2 w-100" (click)="returnToCategoryIntorudction()">
                    <mwp-text-translate text="Return To Category Introduction" jsonKey="returnToCategoryIntroduction" />
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
    <div class="col-10 content-selections">
      @if (isLoadingCategory) {
        <div>
          <mwp-placeholder-table [displayButton]="true" />
        </div>
      }
      @if (!isLoadingCategory) {
        <div>
          @if (!isFauxCategory) {
            <div>
              @if (displayCategoryManagerControl) {
                <mwp-benefit-enrollment-category
                  [enrollmentCategoryOptions]="selectedEnrollmentCategoryOptions"
                  [benefitSummaryList]="currentBenefitsList" (selectWizardEmit)="wizardIntialize($event)"
                  [displayResourcesButton]="displayResources"
                  (categoryResourcesSelectedEmit)="openResourceSummaryDialog()"
                  (nextCategorySelectedEmit)="loadNextCatgory()"
                  [toggleCategoryIntroduction]="toggleCategoryIntroduction"
                  [isEnrollmentMode]="true" />
              }
              @if (displayBenefitWizardControl) {
                <mwp-benefit-enrollment-wizard
                  (emitWizardComplete)="buildCategoryFinalize($event)" />
              }
              @if (displayBenefitWidgetControl) {
                <mwp-benefit-enrollment-wizard-widget
                  (emitWizardComplete)="buildCategoryFinalize($event)"
                  (emitWidgetError)="buildWidgetErrorCategoryFinalizePanel($event)" />
              }
              @if (displayCategoryFinalizeControl) {
                <mwp-benefit-enrollment-category-finalize
                  [isCheckoutEnabled]="enrollmentManagerService.manager.isCheckoutEnabled"
                  [nextCategory]="nextEnrollmentBenefitCategoryItem"
                  (currentCategroy)="reloadCurrentCategoryBenefits()" (gotoNextCategroy)="loadNextCatgory()"
                  (initializeCheckout)="initializeCheckout()" />
              }
              @if (displayCheckoutControl) {
                <mwp-benefit-enrollment-checkout
                  (emitIntializeComplete)="loadingComplete()" />
              }
            </div>
          }
          @if (isFauxCategory) {
            <div>
              <mwp-benefit-enrollment-faux-category
                [enrollmentCategoryOptions]="selectedEnrollmentCategoryOptions"
                (gotoNextCategroy)="nextCategoryAfterFaux()" />
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

@if (checkoutComplete) {
  <div>
    <div class="enrollment-container content-container mb-3">
      <div class="title">
        {{ checkoutComplete.title }}
      </div>
      <div class="content pb-3">
        <div [innerHtml]="checkoutComplete.message | pipeSafeHTML" class="mb-3">
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end w-100">
      <button class="mwp-button" (click)="returnToBenefitsDashboard()">
        <mwp-text-translate text="Return to Benefits Dashboard" jsonKey="returnToBenefitsDashboard" />
      </button>
    </div>
  </div>
}